import Authenticators from '../../services/Authenticators';
import Vue from 'vue';
import JsSHA from "jssha";
import _ from 'lodash';

const addAuthenticator = function (state, model) {
  model.showOtp = state.showOtp;
  Vue.set(state.all, model.id, model);
};

const dec2hex = function (s) {
  return (s < 15.5 ? '0' : '') + Math.round(s)
    .toString(16);
};

const hex2dec = function (s) {
  return parseInt(s, 16);
};

const leftpad = function (str, len, pad) {
  if (len + 1 >= str.length) {
    str = Array(len + 1 - str.length)
      .join(pad) + str; // eslint-disable-line no-param-reassign
  }
  return str;
};

const multiIncludes = function (text, values) {
  var re = new RegExp(values.join('|'), 'i');
  return re.test(text);
};

const base32tohex = function (base32) {
  var base32chars = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567";
  var bits = "";
  var hex = "";

  for (let i = 0; i < base32.length; i++) {
    var val = base32chars.indexOf(base32.charAt(i)
      .toUpperCase());
    bits += leftpad(val.toString(2), 5, '0');
  }

  for (let y = 0; y + 4 <= bits.length; y += 4) {
    var chunk = bits.substr(y, 4);
    hex += parseInt(chunk, 2)
      .toString(16);
  }
  return hex;
};

const regex = /[^a-zA-Z0-9]+/g;

const generate = key => {
  if (key.length  === 0) {
    return '';
  }

  let otp = '';
  try {
  key = key.replace(regex, '');

    var epoch = Math.round(new Date().getTime() / 1000.0);
    var time = leftpad(dec2hex(Math.floor(epoch / 30)), 16, '0');

    var shaObj = new JsSHA("SHA-1", "HEX");
    shaObj.setHMACKey(base32tohex(key), "HEX");
    shaObj.update(time);
    var hmac = shaObj.getHMAC("HEX");
    if (hmac == 'KEY MUST BE IN BYTE INCREMENTS') {
      return '';
    }
    var offset = hex2dec(hmac.substring(hmac.length - 1));
    // otp = (hex2dec(hmac.substr(offset * 2, 8)) & hex2dec('7fffffff')) + '';
    otp = String(hex2dec(hmac.substr(offset * 2, 8)) & hex2dec('7fffffff'));
    otp = (otp).substr(otp.length - 6, 6);
  } catch ($e) {
    // do nothing
  }
  return otp;
};

const state = {
  all: {},
  favorites: [],
  templateId: false,
  siteId: null,
  personalFolderId: null,
  settingsId: null,
  filterTemplateOn: [
    "auth",
  ],
  filterFieldOn: [
    "restorecode",
    "authcode",
  ],
};

const getters = {
  all: () => {
    return state.all;
  },
  favorites: () => {
    return state.favorites;
  },
  templateId: () => {
    return state.templateId;
  },
  personalFolderId: () => {
    return state.personalFolderId;
  },
  settingsId: () => {
    return state.settingsId;
  },
  filterTemplateOn: () => {
    return state.filterTemplateOn;
  },
  filterFieldOn: () => {
    return state.filterFieldOn;
  },
  getById: state => id => {
    return state.all[id];
  },
  siteId: () => {
    return state.siteId;
  }

};

const extractSecret = function (payload) {
  let fieldId = findFieldId(payload);
  let input = _.filter(payload.items, field => {
    if (field.fieldId == fieldId) {
      return true;
    }
  });
  if (!input || Object.keys(input).length == 0) {
    return false;
  }
  let secret = input[0].itemValue;
  if (secret) {
    return secret;
  }
  return 0;
};

const findFieldId = function (payload) {
  // Fields
  let fieldId = false;
  _.filter(payload.items, item => {
    if (item.fieldName == "") return false;
    let name = multiIncludes(item.fieldName, getters.filterFieldOn());

    if (name) {
      fieldId = item.fieldId;
      return true;
    }
  });
  return fieldId;
};

const actions = {
  getAuthenticators({commit}, params) {
    return Authenticators.getAuthenticators(params)
      .then(data => commit('receiveAll', data.records));
  },
  getAuthenticator({commit}, payload) {
    return Authenticators.getAuthenticator(payload)
      .then(data => commit('receiveAuthenticator', data));
  },
  setTemplateId({commit}, id) {
    return commit('setTemplateId', id);
  },
  setSettingsId({commit}, id) {
    return commit('setSettingsId', id);
  },
  setPersonalFolderId({commit}, id) {
    return commit('setPersonalFolderId', id);
  },
  setSiteId({commit}, id) {
    return commit('setSiteId', id);
  },
  generateOtp({commit}, payload) {
    let secret = extractSecret(state.all[payload]);
    if (secret) {
      return commit('setOtp', {id: payload, otp: generate(secret)});
    }
    return false;
  },
  toggleShowOtp({commit}, payload) {
    return commit('toggleShowOtp', payload);
  },
  toggleFavorite({commit}, id) {
    return commit('toggleFavorite', id);
  },
  addFieldFilter({commit}, payload) {
    return commit('addFieldFilter', payload);
  },
  addTemplateFilter({commit}, payload) {
    return commit('addTemplateFilter', payload);
  },
  removeFieldFilter({commit}, payload) {
    return commit('removeFieldFilter', payload);
  },
  removeTemplateFilter({commit}, payload) {
    return commit('removeTemplateFilter', payload);
  },
  resetFieldFilter({commit}) {
    return commit('resetFieldFilter');
  },
  resetTemplateFilter({commit}) {
    return commit('resetTemplateFilter');
  },
  setFieldFilter({commit}, payload) {
    return commit('resetFieldFilter', payload);
  },
  setTemplateFilter({commit}, payload) {
    return commit('resetTemplateFilter', payload);
  },
  clearState({commit}) {
    return commit('clearState');
  },
  clearAll({commit}) {
    return commit('clearAll');
  },
  searchSecrets({commit}, payload) {
    return Authenticators.searchSecrets(payload);
  },
  getStub({commit}) {
    return Authenticators.getStub();
  },
  getSecret({commit}, id) {
    return Authenticators.getSecret(id);
  },
  putSecret({commit}, id, payload) {
    return Authenticators.putSecret(id, payload);
  },
  postSecret({commit}, payload) {
    return Authenticators.postSecret(payload);
  },
  postPreferences({commit}) {
    return Authenticators.postPreferences();
  },
  getPreferences({commit}, config) {
    return Authenticators.getPreferences(config);
  },
  getCompanyPreferences({commit}) {
    return Authenticators.getCompanyPreferences();
  },
  getPersonalFolderId({commit}) {
    return Authenticators.getPersonalFolderId();
  },
  getFolders(params) {
    return Authenticators.getFolders(params);
  },
  patchSecretField(id, params) {
    return Authenticators.patchSecretField(id, params);
  },
};

const mutations = {
  clearState(state) {
    state.all = {};
    state.favorites = [];
    state.templateId = false;
    state.settingsId = false;
    state.personalFolderId = null;
    state.siteId = null;
    state.filterTemplateOn = [
      "auth",
    ];
    state.filterFieldOn = [
      "restorecode",
      "authcode",
    ];
  },
  receiveAll(state, models) {
    models.forEach(model => {
      addAuthenticator(state, model);
    });
    if (state.siteId == null) {
      if (models[0] && models[0].siteId !== null) {
        state.siteId = Number([models[0].siteId]);
      } else {
        state.siteId = 1;
      }
    }
  },
  clearAll(state) {
    state.all = {};
  },
  receiveAuthenticator(state, model) {
    let secret = extractSecret(model);
    model.otp = generate(secret);
    addAuthenticator(state, model);
  },
  addFieldFilter(state, payload) {
    state.filterFieldOn.push(payload);
    localStorage.setItem('fieldFilter', JSON.stringify(state.filterFieldOn));
  },
  removeFieldFilter(state, payload) {
    state.filterFieldOn.splice(payload, 1);
    localStorage.setItem('fieldFilter', JSON.stringify(state.filterFieldOn));
  },
  resetFieldFilter(state) {
    state.filterFieldOn = [
      "restorecode",
      "authcode",
    ];
    localStorage.setItem('fieldFilter', JSON.stringify(state.filterFieldOn));
  },
  setSiteId(state, id) {
    state.siteId = id;
  },
  setSettingsId(state, id) {
    state.settingsId = id;
  },
  setPersonalFolderId(state, id) {
    state.personalFolderId = id;
  },
  setFieldFilter(state, payload) {
    state.filterFieldOn = payload;
    localStorage.setItem('fieldFilter', JSON.stringify(state.filterFieldOn));
  },
  addTemplateFilter(state, payload) {
    state.filterTemplateOn.push(payload);
    localStorage.setItem('templateFilter', JSON.stringify(state.filterTemplateOn));
  },
  removeTemplateFilter(state, payload) {
    state.filterTemplateOn.splice(payload, 1);
    localStorage.setItem('templateFilter', JSON.stringify(state.filterTemplateOn));
  },
  resetTemplateFilter(state) {
    state.filterTemplateOn = [
      "auth",
    ];
    localStorage.setItem('templateFilter', JSON.stringify(state.filterTemplateOn));
  },
  setTemplateFilter(state, payload) {
    state.filterTemplateOn = payload;
    localStorage.setItem('templateFilter', JSON.stringify(state.filterTemplateOn));
  },
  setOtp(state, payload) {
    state.all[payload.id].otp = payload.otp;
  },
  toggleShowOtp(state, id) {
    state.all[id].showOtp = !state.all[id].showOtp;
  },
  toggleFavorite(state, id) {
    let index = state.favorites.indexOf(id);
    if (index >= 0) {
      state.favorites.splice(index, 1);
    } else {
      state.favorites.push(id);
    }
  },
  setFavorites(state, payload) {
    state.favorites = payload;
  },
  setTemplateId(state, id) {
    state.templateId = id;
    localStorage.setItem('templateId', id);
  },
  loadOffline(state, store) {
    state.all = store.all;
    state.templateId = store.templateId;
    state.siteId = store.siteId;
    state.personalFolderId = store.personalFolderId;
    state.settingsId = store.settingsId;
    state.filterTemplateOn = store.filterTemplateOn;
    state.filterFieldOn = store.filterFieldOn;
    state.favorites = store.favorites;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/authenticators.js